module.exports = __webpack_public_path__ + "static/img/choubae_ka.9735881.jpg";